import React from "react"
import styled from "@emotion/styled/macro"
import { theme, device } from "../Theme"
import BgRedBtn from "../../images/btn-red-bg.png"

const StyledButton = styled.button`
  padding: 16px 38px 20px;
  font-size: 17px;
  line-height: 21px;
  font-family: ${theme.fonts.altFont};
  font-weight: 700;
  background: url(${BgRedBtn});
  border: none;
  color: #fff;
  text-transform: uppercase;
  cursor: pointer;
  width: 258px;

  ${props =>
    props.type === "primary" &&
    `
    background: #E32223;
  `}

  ${props =>
    props.type === "secondary" &&
    `
    background: #000000;
  `}

  @media ${device.max_lg} {
    font-size: 15px;
    line-height: 16px;
    padding: 16px 25px;
  }
`

const Button = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>
}

export default Button
